export default __webpack_public_path__ + "2dc22084e7319fe0f9f385d03c2fe698.png";